import { snakeToSpaces } from "../../utils";
import { Button } from "../Button";
import React from "react";

export default function Header({
  title = "",
  isExpanded = false,
  onExpand = () => {},
  resetChildren = () => {},
}) {
  return (
    <div className="flex flex-row items-center justify-between ">
      <div className="flex flex-row items-center">
        <div className="pointer bold" onClick={onExpand}>
          {
            <svg
              // className="ml1 pointer"
              className={`filter-group__indicator ${
                isExpanded ? `filter-group__indicator--expanded` : ``
              }`}
              fill="var(--secondary-color)"
              // stroke="var(--secondary-color)"
              role="img"
              aria-label="expand filter group"
            >
              <use xlinkHref="#chevron-down" />"
            </svg>
          }
        </div>
        <div className="uppercase pointer bold" onClick={onExpand}>
          {snakeToSpaces(title).toLowerCase()}
        </div>
      </div>
      <Button
        className="rounded uppercase h6 ml1 block-font"
        onClick={resetChildren}
      >
        Reset
      </Button>
    </div>
  );
}
